import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import axios from 'axios'
import { FormattedMessage  } from 'react-intl';

import LoadingControl from './Loading';
import { PRINTERS_PATH, USERS_PATH, COMPUTERS_PATH, DOCUMENTS_PATH } from '../utils/constants';
import { getCurrencySymbol, formatBytes } from '../utils/utils';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import DescriptionObject from './DescriptionObject';
import DocumentsTable from './DocumentsTable';
import ChartDistribution from './ChartDistribution';
import { GetMostActiveColumns } from './GetMostActiveObjectsColumn';
import MostActiveObjectsTable from './MostActiveObjectsTable';

const ComputerReportGeneral = (props) => {
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        computer: null
    });

    async function getData() {

        var url = ApplyFilterParams("/computer/" + props.compId + "?doNotReturnEmptyObjects=false", props.filterData);
        
        const res = await axios(url);
        return res.data;
        }

    useEffect(() => {
        if (props.compId)
        {
            setState( {error: {message : "Bad computer id"}});
        }
        setState({isLoaded: false});
    
        getData()
        .then(res => {
            setState({ error: null, isLoaded: true, computer: getColumns(res) });
        })
        .catch(err => {
            setState( {error: err, isLoaded: false, computer: null });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.compId]);    


    let daysNumber = useRef();

    function getColumns(res)
    {
        const lang = navigator.language || navigator.userLanguage;

        var data = [];
        if ((res instanceof Array) && res.length > 0)
        {
            data = data = res[0];
        }

        let dateMin = new Date(data.minDate);
        let dateMax = new Date(data.maxDate);

        let reportPeriod = "";
        if (isNaN(dateMin) || isNaN(dateMax))
        {
            daysNumber.current = null;
        }
        else
        {
            daysNumber.current = Math.round(dateMax.getTime() - dateMin.getTime()) / (1000 * 60 * 60 * 24);

            reportPeriod = dateMin.toLocaleDateString(lang) + ' - ' + 
                    dateMax.toLocaleDateString(lang);

        }

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        var columns = [
            {
                title :  <FormattedMessage id="DeviceMetersTable.name"/>,
                data : data.compName,
            },
            {
                title : <FormattedMessage id="Users"/>,
                data : data.users,
                link: USERS_PATH + "?computerId=" + props.compId,
            },
            {
                title : <FormattedMessage id="Printers"/>,
                data : data.printers,
                link: PRINTERS_PATH + "?computerId=" + props.compId,
            },
            {
                title : <FormattedMessage id="Report.PrintedJobs"/>,
                data : data.documents,
                link: DOCUMENTS_PATH + "?computerId=" + props.compId,
            },
            {
                title : <FormattedMessage id="Pages"/>,
                data : data.pages,
            },
            {
                title : <FormattedMessage id="Cost"/>,
                data : currencyFormatter.format(data.cost === undefined ? 0 : data.cost),
            },
            {
                title : <FormattedMessage id="JobDataSize"/>,
                data : formatBytes(data.jobDataSize === undefined ? 0 : data.jobDataSize),
            },
            {
                title : <FormattedMessage id="ReportPeriod"/>,
                data : reportPeriod,
            },
        ];

        return columns;
    }


        if(state.error != null)
        {
            return (
                <div>
                    <h3>{state.error.message}</h3>
                    <Link to={COMPUTERS_PATH}><FormattedMessage id="Back"/></Link>
                </div>
            );
        }
        else if (!state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {          
            if (state.computer === null)
            {
                return ( 
                    <div>
                        <FormattedMessage id="ObjectNotFound"/>
                        <Link to={COMPUTERS_PATH}><FormattedMessage id="Back"/></Link>
                    </div>
                );
            }
            
            return (
            <div>
                <div className = "description-parent">
                    <div className = "description-object"><DescriptionObject object = {state.computer}/></div>
                    <div className = "description-object"><ChartDistribution object_id = {'computerId=' + props.compId}/></div>
                </div>
                <br/>
                <br/>
                <h4><FormattedMessage id="LastDocuments"/></h4>
                <DocumentsTable parent_id_param = {'?computerId=' + props.compId} 
                                api_url = {ApplyFilterParams('job?maxCount=20&compId=' + props.compId, props.filterData)}/>
                <h4><FormattedMessage id="MostActiveUsers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?computerId=' + props.compId} 
                    api_url = {ApplyFilterParams('user?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&computerId=' + props.compId, props.filterData)}
                    days_number = {daysNumber.current}
                    get_columns = {GetMostActiveColumns(USERS_PATH, '?computerId=' + props.compId, daysNumber.current)}
                />
                <h4><FormattedMessage id="MostActivePrinters"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?computerId=' + props.compId} 
                    api_url = {ApplyFilterParams('printer_ex?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&computerId=' + props.compId, props.filterData)}
                    get_columns = {GetMostActiveColumns(PRINTERS_PATH, '?computerId=' + props.compId, daysNumber.current)}

                />
            </div>
            )
        }    
}

export default ComputerReportGeneral;